// PostMedia.js
import { connect } from 'react-redux';

import getAssetData from '../selector/getAssetData.js';
import getMessageData from '../selector/getMessageData.js';
import getOperationData from '../selector/getOperationData.js';
import PostMedia from '../component/PostMedia.jsx';
import { push } from '../action/navigationAction.js';
import addMessage from '../action/addMessage.js';
import setPostMediaIntersectingData from '../action/setPostMediaIntersectingData.js';
import setMediaHeightInPostFeed from '../action/setMediaHeightInPostFeed.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import withRouter from '../component/WithRouter.jsx';

import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import { MediaAssetFormat } from '../resource/getMediaAsset.js';

const mapStateToProps = (state, { postId, location }) => {
  const activeAssetId = getMessageData(state, postId, 'activeAssetId');
  const activeAssetMediaType = getAssetData(
    state,
    [activeAssetId],
    'contentType'
  );
  const isActiveAssetVideoType = activeAssetMediaType?.startsWith('video');
  return {
    isPlayerSeeking: getOperationData(state, ['player'], 'isSeeking'),
    assetIds: getMessageData(state, postId, 'assetIds'),
    activeAssetId,
    isOnPostDetail: getIsMatchedPathname({
      pathname: location?.pathname,
      dataKey: 'isOnPostDetail',
    }),
    mediaHeightInPostFeed: getMessageData(
      state,
      postId,
      'mediaHeightInPostFeed'
    ),
    isActiveAssetVideoType,
    thumbnail: getMessageThumbnail(
      state,
      postId,
      activeAssetId,
      '64x64',
      MediaAssetFormat.JPG,
      'blurred'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: (...args) => dispatch(push(...args)),
    setPostMediaIntersectingData: data =>
      dispatch(setPostMediaIntersectingData(data)),
    setMediaHeightInPostFeed: ({
      messageId,
      imageElement,
      mediaWrapperElement,
    }) =>
      dispatch(
        setMediaHeightInPostFeed({
          messageId,
          imageElement,
          mediaWrapperElement,
        })
      ),
    setPostActiveAssetId: ({ postId, activeAssetId }) =>
      dispatch(
        addMessage({
          message: {
            id: postId,
            activeAssetId,
          },
        })
      ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostMedia)
);
